export const ActionTypes = {
    SET_PRODUCTS : "SET_PRODUCTS",
    SELECTED_PRODUCT : "SELECTED_PRODUCT",
    REMOVE_SELECTED_PRODUCT : "REMOVE_SELECTED_PRODUCT",
    ADD_CART_PRODUCT : "ADD_CART_PRODUCT",
    INCREASE_PRODUCT_QUANTITY : "INCREASE_PRODUCT_QUANTITY",
    DECREASE_PRODUCT_QUANTITY  : "DECREASE_PRODUCT_QUANTITY",
    DELETE_PRODUCT_FROM_CART : "DELETE_PRODUCT_FROM_CART"
};